import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <IndexSection />
        <MediaSection />
        <FeaturesSection />
        <ContactSection />
        <RankingSection />
        <AboutSection />
        <CommentsSection />
        <CardsSection />
        <UpdatesSection />
        <FaqSection />
        <TopicsSection />
        <AppSection />
        <CarouselSection />
      </main>

      <Footer />
    </div>
  );
}